import Spacer from '@berlitz/spacer'
import { WarningModal } from '@components/Modal'
import { CANCEL_SESSIONS } from '@mutations/sessions'
import { CANCELLATION_REASONS } from '@utils/constants'
import * as React from 'react'
import { Mutation } from 'react-apollo'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'

interface CancelLessonProps extends InjectedIntlProps {
  open: boolean
  hasCancelError: boolean
  onClose: () => void
  onProceed: Function
  SFId: string
  SessionId: string
  cancelsRemaining?: number
}

const CancelLesson: React.FC<CancelLessonProps> = ({
  open,
  onClose,
  onProceed,
  hasCancelError,
  SessionId,
  intl,
  cancelsRemaining,
}) => {
  const title = intl.formatMessage({
    id: hasCancelError ? 'An unknown error has occurred. Please try again later.' : 'Cancel lesson',
  })

  const description = hasCancelError ? (
    ''
  ) : (
    <div>
      <FormattedMessage id="Are you sure you want to cancel this lesson?" />
      <Spacer />
      <FormattedMessage id="Cancels remaining:" /> {cancelsRemaining}
      <Spacer />
    </div>
  )

  return (
    <Mutation mutation={CANCEL_SESSIONS}>
      {cancelLessons => {
        return (
          <WarningModal
            open={open}
            onClose={onClose}
            onProceed={async () => {
              onProceed({ loading: true, error: false })

              try {
                const res = await cancelLessons({
                  variables: {
                    Ids: [SessionId],
                    CancellationReason: CANCELLATION_REASONS.STUDENT_CANCELLATION,
                  },
                })
                onProceed({ ...res, loading: false, error: false })
              } catch (error) {
                onProceed({ loading: false, error: true })
              }
            }}
            title={title}
            description={description}
            proceedLabel={intl.formatMessage({
              id: 'Cancel lesson',
            })}
            cancelLabel={intl.formatMessage({ id: 'Keep lesson' })}
            noButtons={hasCancelError}
          />
        )
      }}
    </Mutation>
  )
}

export default injectIntl(CancelLesson)
